import { EllipsisVerticalIcon } from "lucide-react";
import { useMemo, useState } from "react";

import AddFromRequestHistoryButton from "./AddFromRequestHistoryButton";
import ArchiveButton from "./ArchiveButton";
import EditButton from "./EditButton";
import { useDeleteAllRows } from "./hooks/useDeleteAllRows";
import { useDeleteDataset } from "./hooks/useDeleteDataset";
import { useDownloadDataset } from "./hooks/useDownloadDataset";
import UploadDataButton from "./UploadDataButton";
import { VersionSelector } from "./VersionSelector";

import { DropdownMenu } from "@/components/ui/DropdownMenu";

interface DatasetActionButtonsProps {
  handleDeleteDatasetGroup: () => void;
  onDiscard?: () => void;
}

const DatasetActionButtons = ({
  handleDeleteDatasetGroup,
  onDiscard,
}: DatasetActionButtonsProps) => {
  const [, setIsDiscarded] = useState(false);

  const handleSetIsDiscarded = (value: boolean) => {
    setIsDiscarded(value);
    if (value && onDiscard) {
      onDiscard();
    }
  };

  const downloadDataset = useDownloadDataset();
  const deleteAllRows = useDeleteAllRows();
  const deleteDataset = useDeleteDataset({ setIsDiscarded: handleSetIsDiscarded });

  const dropdownActions = useMemo(
    () => [downloadDataset, deleteAllRows, deleteDataset],
    [downloadDataset, deleteAllRows, deleteDataset],
  );

  const visibleDropdownActions = dropdownActions.filter(action => action.shouldShow !== false);

  return (
    <div className="relative bottom-1 flex gap-x-2">
      <VersionSelector handleDeleteDatasetGroup={handleDeleteDatasetGroup} />
      <AddFromRequestHistoryButton />
      <UploadDataButton />
      <EditButton />
      <ArchiveButton onDelete={handleDeleteDatasetGroup} />
      {visibleDropdownActions.length > 0 && (
        <DropdownMenu
          icon={<EllipsisVerticalIcon className="h-4 w-4" />}
          menuItems={dropdownActions}
          triggerClassName="h-8 w-8 justify-center outline-none"
        />
      )}
    </div>
  );
};

export default DatasetActionButtons;
